import axios from "axios";
import { normalizeSensorInterpolation } from "../utils/sensorHeatmapUtils";
import {
  compactParams,
  fetchAllFieldDataImages,
  getFieldDataFilterParams,
  normalizeFieldDataImageDetail,
} from "../utils/fieldDataDiseaseStatusUtils";

const DEFAULT_LIMIT = 100;

export const FIELDDATA_API_BASE_PATH = (
  process.env.REACT_APP_FIELDDATA_API_BASE_PATH || "/fielddata-api"
).replace(/\/+$/, "");

const buildFieldDataPath = (path = "") => {
  const normalizedPath = String(path).replace(/^\/+/, "");
  return normalizedPath ? `/${normalizedPath}` : "";
};

const fieldDataClient = axios.create({
  baseURL: FIELDDATA_API_BASE_PATH,
  timeout: 30000,
});

const getArtichokeRiskApi = async (endpoint, request, signal) => {
  const response = await fieldDataClient.get(buildFieldDataPath(endpoint), {
    params: { field_uuid: request.fieldUuid, start_date: request.from, risk_date: request.to },
    signal,
  });
  return response.data;
};

export const getArtichokePowderyMildewApi = (request, signal) =>
  getArtichokeRiskApi("artichoke_powdery_mildew/", request, signal);

export const getArtichokeDownyMildewApi = (request, signal) =>
  getArtichokeRiskApi("artichoke_downy_mildew/", request, signal);

export const getMelonFungalDiseasesApi = async (request, signal) => {
  const response = await fieldDataClient.get(buildFieldDataPath("melon_fungal_diseases/"), {
    params: {
      field_uuid: request.fieldUuid, risk_date: request.to,
      season_start_date: request.seasonStartDate, melon_type: request.melonType,
    },
    signal,
  });
  return response.data;
};

export const getSensorInterpolationApi = async (request, signal) => {
  const response = await fieldDataClient.get(
    buildFieldDataPath("sensor_interpolation/"),
    {
      params: {
        field_uuid: request.fieldUuid,
        measurement_name: request.measurementName,
        timestamp: request.timestamp,
        output_crs: "EPSG:3857",
      },
      signal,
    },
  );
  return normalizeSensorInterpolation(response.data, request);
};

export const getImageDatesApi = async (fieldFilter) => {
  const response = await fieldDataClient.get(buildFieldDataPath("image_dates/"), {
    params: getFieldDataFilterParams(fieldFilter),
  });

  return response.data;
};

export const getImagesPageApi = async ({
  fieldFilter,
  startTime,
  endTime,
  classification,
  limit = DEFAULT_LIMIT,
  offset = 0,
}) => {
  const response = await fieldDataClient.get(buildFieldDataPath("images/"), {
    params: compactParams({
      ...getFieldDataFilterParams(fieldFilter),
      start_time: startTime,
      end_time: endTime,
      classification,
      limit,
      offset,
      order_by: "timestamp",
      order_dir: "desc",
    }),
  });

  return response.data;
};

export const getImageDetailApi = async (imageId) => {
  const response = await fieldDataClient.get(
    buildFieldDataPath(`image/${imageId}`),
  );

  return normalizeFieldDataImageDetail(response.data);
};

export const fetchAllImages = async ({
  fieldFilter,
  startTime,
  endTime,
  classification,
  requestPage = getImagesPageApi,
  limit = DEFAULT_LIMIT,
}) =>
  fetchAllFieldDataImages({
    fieldFilter,
    startTime,
    endTime,
    classification,
    requestPage,
    limit,
  });
